import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customerSearch'
})
export class CustomerSearchPipe implements PipeTransform {

  transform(value: any, input: string) {
    if (input) {
      input = input.toLowerCase();
      return value.filter( (ele) => {
        let person = ele.personenIntro[0];
        let str : string = [person.vorname, person.nachname].filter(( e )=>{ return !!e; }).join( ' ' );
        return  str.toLowerCase().indexOf(input) > -1;
      })
    }
    return value;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/customer-search.pipe.ts